// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Daily Insights — a month of FOB value, with a week rail beside it. */

.fcal { display: flex; flex-direction: column; gap: 12px; min-height: 0; }

/* ── toolbar ─────────────────────────────────────────────────────────────── */
.fcal__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.fcal__nav { display: flex; align-items: center; gap: 10px; }

.fcal__arrow {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid #e3e9f3;
  background: #fff;
  color: #475569;
  cursor: pointer;
  transition: background-color 140ms ease, color 140ms ease, border-color 140ms ease;
}
.fcal__arrow:hover { background: #eff4ff; color: #1d4ed8; border-color: #c7d9ff; }
.dark .fcal__arrow { background: #16203a; border-color: #2a3650; color: #9fb0cc; }
.dark .fcal__arrow:hover { background: #1e2a45; color: #cfe0ff; }

.fcal__month {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  white-space: nowrap;
}
.dark .fcal__month { color: #f1f5f9; }

.fcal__thismonth {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #e3e9f3;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.fcal__thismonth:hover:not(:disabled) { background: #eff4ff; color: #1d4ed8; }
.fcal__thismonth:disabled { opacity: 0.5; cursor: default; }
.dark .fcal__thismonth { background: #16203a; border-color: #2a3650; color: #9fb0cc; }

/* ── monthly stat chips ──────────────────────────────────────────────────── */
.fcal__stats { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-left: auto; }

.fcal__statslabel { font-size: 13px; font-weight: 600; color: #64748b; }
.dark .fcal__statslabel { color: #8da2c0; }

.fcal__chip {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 7px 14px;
  border-radius: 13px;
  border: 1px solid transparent;
}
.fcal__chip b { display: block; font-size: 15px; font-weight: 800; line-height: 1.15; }
.fcal__chip span { display: block; font-size: 11px; font-weight: 600; opacity: 0.85; }

.fcal__chip--fob    { background: #eaf1ff; border-color: #d3e1ff; color: #1d4ed8; }
.fcal__chip--count  { background: #e9f9f0; border-color: #c9f0dc; color: #047857; }
.fcal__chip--client { background: #fff4e6; border-color: #ffe3c2; color: #b45309; }
.dark .fcal__chip--fob    { background: rgba(59,130,246,.14);  border-color: rgba(59,130,246,.28);  color: #9cc4ff; }
.dark .fcal__chip--count  { background: rgba(16,185,129,.13);  border-color: rgba(16,185,129,.28);  color: #6ee7b7; }
.dark .fcal__chip--client { background: rgba(245,158,11,.13);  border-color: rgba(245,158,11,.28);  color: #fcd34d; }

/* ── layout: grid + week rail ────────────────────────────────────────────── */
.fcal__body { display: grid; grid-template-columns: 1fr; gap: 12px; min-height: 0; }
@media (min-width: 1100px) { .fcal__body { grid-template-columns: 1fr 218px; } }

.fcal__scroll { overflow: auto; min-height: 0; }

.fcal__grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(104px, 1fr));
  gap: 6px;
  min-width: 820px;
}

.fcal__weekday {
  padding: 6px 0;
  border-radius: 10px;
  background: #f3f6fc;
  color: #64748b;
  font-size: 12.5px;
  font-weight: 700;
  text-align: center;
}
.dark .fcal__weekday { background: #16203a; color: #93a4c1; }

/* ── a day ───────────────────────────────────────────────────────────────── */
.fcal__cell {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 88px;
  padding: 8px 10px 9px 12px;
  border-radius: 14px;
  border: 1px solid #e8edf6;
  background: #fff;
  text-align: left;
  cursor: default;
  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
}
.dark .fcal__cell { background: #121b2f; border-color: #253147; }

.fcal__cell--outside { background: #fafbfe; border-color: #eef1f7; }
.dark .fcal__cell--outside { background: #0e1626; border-color: #1c2740; }

.fcal__cell--has {
  cursor: pointer;
  background: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);
  border-color: #dde7fa;
}
.fcal__cell--has::before {
  content: '';
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #2563eb;
  opacity: 0.75;
}
.fcal__cell--has:hover { border-color: #b9d0ff; box-shadow: 0 8px 22px -14px rgba(37,99,235,.5); }
.dark .fcal__cell--has {
  background: linear-gradient(180deg, #16203a 0%, #131c33 100%);
  border-color: #2b3b5c;
}
.dark .fcal__cell--has:hover { border-color: #3b5a92; }

.fcal__cell--today { border-color: #93c5fd; }
.dark .fcal__cell--today { border-color: #3b5a92; }

.fcal__cell--open {
  border-color: #3b82f6;
  background: #f2f7ff;
  box-shadow: 0 0 0 3px rgba(59,130,246,.14);
}
.dark .fcal__cell--open { background: #16243f; border-color: #4b84e8; }

.fcal__cell--inweek {
  border-color: #7aa7f5;
  background: #eef4ff;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.14);
}
.dark .fcal__cell--inweek {
  border-color: #4b84e8;
  background: rgba(59, 130, 246, 0.12);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

/* the rest of the month steps back so the picked week reads as a band */
.fcal__cell--dim { opacity: 0.4; }

.fcal__daynum { font-size: 14px; font-weight: 700; color: #0f172a; }
.dark .fcal__daynum { color: #e7eefc; }
.fcal__cell--outside .fcal__daynum { color: #b6bfd0; }
.dark .fcal__cell--outside .fcal__daynum { color: #4c5a75; }

.fcal__badge {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
}
.fcal__badge--doc { background: #10b981; }

.fcal__count {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #7c8aa3;
}
.dark .fcal__count { color: #8496b3; }
.fcal__dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

.fcal__fob {
  font-size: 17.5px;
  font-weight: 900;
  letter-spacing: -0.015em;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
  color: #0b1220;
}
.dark .fcal__fob { color: #ffffff; }

.fcal__extra {
  margin-top: 2px;
  padding-top: 5px;
  border-top: 1px dashed #d7e2f5;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dark .fcal__extra { border-top-color: #2f3e5c; }
.fcal__extra div {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 10.5px;
  font-weight: 600;
  color: #64748b;
}
.dark .fcal__extra div { color: #93a4c1; }
.fcal__extra b { color: #334155; font-weight: 700; }
.dark .fcal__extra b { color: #cbd5e1; }

/* ── week rail ───────────────────────────────────────────────────────────── */
.fcal__weeks { display: flex; flex-direction: column; gap: 8px; overflow-y: auto; min-height: 0; }

.fcal__week {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 11px;
  border-radius: 14px;
  border: 1px solid #e8edf6;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.fcal__week:hover { border-color: #b9d0ff; box-shadow: 0 8px 22px -14px rgba(37,99,235,.5); }
.dark .fcal__week { background: #121b2f; border-color: #253147; }
.dark .fcal__week:hover { border-color: #3b5a92; }

.fcal__week.is-open { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.14); }

.fcal__weekname { font-size: 13px; font-weight: 800; color: #0f172a; }
.dark .fcal__weekname { color: #e7eefc; }
.fcal__weekrange { font-size: 11px; font-weight: 500; color: #94a3b8; }
.fcal__weekfob { margin-top: 3px; font-size: 15px; font-weight: 800; color: #0f172a; }
.dark .fcal__weekfob { color: #f1f5f9; }
.fcal__weekcount { font-size: 11px; font-weight: 600; color: #64748b; }
.dark .fcal__weekcount { color: #93a4c1; }

.fcal__spark { display: flex; align-items: flex-end; gap: 2px; height: 26px; flex-shrink: 0; }
.fcal__spark i { width: 6px; border-radius: 2px; display: block; }

/* ── footer summary ──────────────────────────────────────────────────────── */
.fcal__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid #e8edf6;
  background: #fbfcff;
}
.dark .fcal__summary { background: #101828; border-color: #253147; }

.fcal__sumcard {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 15px;
  border: 1px solid #e8edf6;
  background: #fff;
  flex: 1 1 165px;
  min-width: 0;
}
.dark .fcal__sumcard { background: #16203a; border-color: #2a3650; }

.fcal__sumicon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 13px;
  flex-shrink: 0;
}
.fcal__sumlabel {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8294ae;
}
.dark .fcal__sumlabel { color: #7f90ad; }
.fcal__sumvalue {
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.015em;
  font-variant-numeric: tabular-nums;
  color: #0b1220;
}
.dark .fcal__sumvalue { color: #ffffff; }

.fcal__delta {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 999px;
  background: #e9f9f0;
  color: #047857;
  font-size: 10.5px;
  font-weight: 800;
  flex-shrink: 0;
}
.dark .fcal__delta { background: rgba(16,185,129,.14); color: #6ee7b7; }

.fcal__empty {
  padding: 48px 0;
  text-align: center;
  font-size: 14px;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/FobCalendar.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,QAAQ,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,aAAa,EAAE;;AAEzE,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA,aAAa,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACjF,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACjF,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA,qBAAqB,cAAc,EAAE;;AAErC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,wCAAwC,mBAAmB,EAAE,cAAc,EAAE;AAC7E,4BAA4B,YAAY,EAAE,eAAe,EAAE;AAC3D,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAErF,+EAA+E;AAC/E,eAAe,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAElG,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,0BAA0B,cAAc,EAAE;;AAE1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,gBAAgB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACtF,mBAAmB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE;;AAErF,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClF,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClF,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClF,4BAA4B,gCAAgC,GAAG,kCAAkC,GAAG,cAAc,EAAE;AACpH,4BAA4B,gCAAgC,GAAG,kCAAkC,GAAG,cAAc,EAAE;AACpH,4BAA4B,gCAAgC,GAAG,kCAAkC,GAAG,cAAc,EAAE;;AAEpH,+EAA+E;AAC/E,cAAc,aAAa,EAAE,0BAA0B,EAAE,SAAS,EAAE,aAAa,EAAE;AACnF,6BAA6B,cAAc,gCAAgC,EAAE,EAAE;;AAE/E,gBAAgB,cAAc,EAAE,aAAa,EAAE;;AAE/C;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;AACA,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEhE,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEzE;EACE,eAAe;EACf,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;AACA,yBAAyB,qBAAqB,EAAE,+CAA+C,EAAE;AACjG;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA,+BAA+B,qBAAqB,EAAE;;AAEtD,qBAAqB,qBAAqB,EAAE;AAC5C,2BAA2B,qBAAqB,EAAE;;AAElD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEtE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA,wEAAwE;AACxE,mBAAmB,YAAY,EAAE;;AAEjC,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE,sBAAsB,cAAc,EAAE;AACtC,qCAAqC,cAAc,EAAE;AACrD,2CAA2C,cAAc,EAAE;;AAE3D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,qBAAqB,cAAc,EAAE;AACrC,aAAa,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE1E;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;AACA,mBAAmB,cAAc,EAAE;;AAEnC;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,qBAAqB,yBAAyB,EAAE;AAChD;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,yBAAyB,cAAc,EAAE;AACzC,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,uBAAuB,cAAc,EAAE;;AAEvC,+EAA+E;AAC/E,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,aAAa,EAAE;;AAEjG;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA,oBAAoB,qBAAqB,EAAE,+CAA+C,EAAE;AAC5F,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;AAChE,0BAA0B,qBAAqB,EAAE;;AAEjD,sBAAsB,qBAAqB,EAAE,0CAA0C,EAAE;;AAEzF,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,wBAAwB,cAAc,EAAE;AACxC,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,iBAAiB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrF,uBAAuB,cAAc,EAAE;AACvC,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,yBAAyB,cAAc,EAAE;;AAEzC,eAAe,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE;AAC7F,iBAAiB,UAAU,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAEjE,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA,wBAAwB,cAAc,EAAE;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,cAAc;AAChB;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,qBAAqB,gCAAgC,EAAE,cAAc,EAAE;;AAEvE;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Daily Insights — a month of FOB value, with a week rail beside it. */\n\n.fcal { display: flex; flex-direction: column; gap: 12px; min-height: 0; }\n\n/* ── toolbar ─────────────────────────────────────────────────────────────── */\n.fcal__bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.fcal__nav { display: flex; align-items: center; gap: 10px; }\n\n.fcal__arrow {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid #e3e9f3;\n  background: #fff;\n  color: #475569;\n  cursor: pointer;\n  transition: background-color 140ms ease, color 140ms ease, border-color 140ms ease;\n}\n.fcal__arrow:hover { background: #eff4ff; color: #1d4ed8; border-color: #c7d9ff; }\n.dark .fcal__arrow { background: #16203a; border-color: #2a3650; color: #9fb0cc; }\n.dark .fcal__arrow:hover { background: #1e2a45; color: #cfe0ff; }\n\n.fcal__month {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  white-space: nowrap;\n}\n.dark .fcal__month { color: #f1f5f9; }\n\n.fcal__thismonth {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 12px;\n  border: 1px solid #e3e9f3;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.fcal__thismonth:hover:not(:disabled) { background: #eff4ff; color: #1d4ed8; }\n.fcal__thismonth:disabled { opacity: 0.5; cursor: default; }\n.dark .fcal__thismonth { background: #16203a; border-color: #2a3650; color: #9fb0cc; }\n\n/* ── monthly stat chips ──────────────────────────────────────────────────── */\n.fcal__stats { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-left: auto; }\n\n.fcal__statslabel { font-size: 13px; font-weight: 600; color: #64748b; }\n.dark .fcal__statslabel { color: #8da2c0; }\n\n.fcal__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  padding: 7px 14px;\n  border-radius: 13px;\n  border: 1px solid transparent;\n}\n.fcal__chip b { display: block; font-size: 15px; font-weight: 800; line-height: 1.15; }\n.fcal__chip span { display: block; font-size: 11px; font-weight: 600; opacity: 0.85; }\n\n.fcal__chip--fob    { background: #eaf1ff; border-color: #d3e1ff; color: #1d4ed8; }\n.fcal__chip--count  { background: #e9f9f0; border-color: #c9f0dc; color: #047857; }\n.fcal__chip--client { background: #fff4e6; border-color: #ffe3c2; color: #b45309; }\n.dark .fcal__chip--fob    { background: rgba(59,130,246,.14);  border-color: rgba(59,130,246,.28);  color: #9cc4ff; }\n.dark .fcal__chip--count  { background: rgba(16,185,129,.13);  border-color: rgba(16,185,129,.28);  color: #6ee7b7; }\n.dark .fcal__chip--client { background: rgba(245,158,11,.13);  border-color: rgba(245,158,11,.28);  color: #fcd34d; }\n\n/* ── layout: grid + week rail ────────────────────────────────────────────── */\n.fcal__body { display: grid; grid-template-columns: 1fr; gap: 12px; min-height: 0; }\n@media (min-width: 1100px) { .fcal__body { grid-template-columns: 1fr 218px; } }\n\n.fcal__scroll { overflow: auto; min-height: 0; }\n\n.fcal__grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(104px, 1fr));\n  gap: 6px;\n  min-width: 820px;\n}\n\n.fcal__weekday {\n  padding: 6px 0;\n  border-radius: 10px;\n  background: #f3f6fc;\n  color: #64748b;\n  font-size: 12.5px;\n  font-weight: 700;\n  text-align: center;\n}\n.dark .fcal__weekday { background: #16203a; color: #93a4c1; }\n\n/* ── a day ───────────────────────────────────────────────────────────────── */\n.fcal__cell {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-height: 88px;\n  padding: 8px 10px 9px 12px;\n  border-radius: 14px;\n  border: 1px solid #e8edf6;\n  background: #fff;\n  text-align: left;\n  cursor: default;\n  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;\n}\n.dark .fcal__cell { background: #121b2f; border-color: #253147; }\n\n.fcal__cell--outside { background: #fafbfe; border-color: #eef1f7; }\n.dark .fcal__cell--outside { background: #0e1626; border-color: #1c2740; }\n\n.fcal__cell--has {\n  cursor: pointer;\n  background: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);\n  border-color: #dde7fa;\n}\n.fcal__cell--has::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 12px;\n  bottom: 12px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: #2563eb;\n  opacity: 0.75;\n}\n.fcal__cell--has:hover { border-color: #b9d0ff; box-shadow: 0 8px 22px -14px rgba(37,99,235,.5); }\n.dark .fcal__cell--has {\n  background: linear-gradient(180deg, #16203a 0%, #131c33 100%);\n  border-color: #2b3b5c;\n}\n.dark .fcal__cell--has:hover { border-color: #3b5a92; }\n\n.fcal__cell--today { border-color: #93c5fd; }\n.dark .fcal__cell--today { border-color: #3b5a92; }\n\n.fcal__cell--open {\n  border-color: #3b82f6;\n  background: #f2f7ff;\n  box-shadow: 0 0 0 3px rgba(59,130,246,.14);\n}\n.dark .fcal__cell--open { background: #16243f; border-color: #4b84e8; }\n\n.fcal__cell--inweek {\n  border-color: #7aa7f5;\n  background: #eef4ff;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.14);\n}\n.dark .fcal__cell--inweek {\n  border-color: #4b84e8;\n  background: rgba(59, 130, 246, 0.12);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n/* the rest of the month steps back so the picked week reads as a band */\n.fcal__cell--dim { opacity: 0.4; }\n\n.fcal__daynum { font-size: 14px; font-weight: 700; color: #0f172a; }\n.dark .fcal__daynum { color: #e7eefc; }\n.fcal__cell--outside .fcal__daynum { color: #b6bfd0; }\n.dark .fcal__cell--outside .fcal__daynum { color: #4c5a75; }\n\n.fcal__badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 8px;\n  background: #2563eb;\n  color: #fff;\n}\n.fcal__badge--doc { background: #10b981; }\n\n.fcal__count {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #7c8aa3;\n}\n.dark .fcal__count { color: #8496b3; }\n.fcal__dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }\n\n.fcal__fob {\n  font-size: 17.5px;\n  font-weight: 900;\n  letter-spacing: -0.015em;\n  line-height: 1.15;\n  font-variant-numeric: tabular-nums;\n  color: #0b1220;\n}\n.dark .fcal__fob { color: #ffffff; }\n\n.fcal__extra {\n  margin-top: 2px;\n  padding-top: 5px;\n  border-top: 1px dashed #d7e2f5;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dark .fcal__extra { border-top-color: #2f3e5c; }\n.fcal__extra div {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #64748b;\n}\n.dark .fcal__extra div { color: #93a4c1; }\n.fcal__extra b { color: #334155; font-weight: 700; }\n.dark .fcal__extra b { color: #cbd5e1; }\n\n/* ── week rail ───────────────────────────────────────────────────────────── */\n.fcal__weeks { display: flex; flex-direction: column; gap: 8px; overflow-y: auto; min-height: 0; }\n\n.fcal__week {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 11px;\n  border-radius: 14px;\n  border: 1px solid #e8edf6;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 140ms ease, box-shadow 140ms ease;\n}\n.fcal__week:hover { border-color: #b9d0ff; box-shadow: 0 8px 22px -14px rgba(37,99,235,.5); }\n.dark .fcal__week { background: #121b2f; border-color: #253147; }\n.dark .fcal__week:hover { border-color: #3b5a92; }\n\n.fcal__week.is-open { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.14); }\n\n.fcal__weekname { font-size: 13px; font-weight: 800; color: #0f172a; }\n.dark .fcal__weekname { color: #e7eefc; }\n.fcal__weekrange { font-size: 11px; font-weight: 500; color: #94a3b8; }\n.fcal__weekfob { margin-top: 3px; font-size: 15px; font-weight: 800; color: #0f172a; }\n.dark .fcal__weekfob { color: #f1f5f9; }\n.fcal__weekcount { font-size: 11px; font-weight: 600; color: #64748b; }\n.dark .fcal__weekcount { color: #93a4c1; }\n\n.fcal__spark { display: flex; align-items: flex-end; gap: 2px; height: 26px; flex-shrink: 0; }\n.fcal__spark i { width: 6px; border-radius: 2px; display: block; }\n\n/* ── footer summary ──────────────────────────────────────────────────────── */\n.fcal__summary {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  border-radius: 18px;\n  border: 1px solid #e8edf6;\n  background: #fbfcff;\n}\n.dark .fcal__summary { background: #101828; border-color: #253147; }\n\n.fcal__sumcard {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 15px;\n  border: 1px solid #e8edf6;\n  background: #fff;\n  flex: 1 1 165px;\n  min-width: 0;\n}\n.dark .fcal__sumcard { background: #16203a; border-color: #2a3650; }\n\n.fcal__sumicon {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 13px;\n  flex-shrink: 0;\n}\n.fcal__sumlabel {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8294ae;\n}\n.dark .fcal__sumlabel { color: #7f90ad; }\n.fcal__sumvalue {\n  font-size: 21px;\n  font-weight: 900;\n  letter-spacing: -0.015em;\n  font-variant-numeric: tabular-nums;\n  color: #0b1220;\n}\n.dark .fcal__sumvalue { color: #ffffff; }\n\n.fcal__delta {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #e9f9f0;\n  color: #047857;\n  font-size: 10.5px;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n.dark .fcal__delta { background: rgba(16,185,129,.14); color: #6ee7b7; }\n\n.fcal__empty {\n  padding: 48px 0;\n  text-align: center;\n  font-size: 14px;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
